import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import './assets/icon/iconfont.css'

// import $ from 'jquery'
// import 'bootstrap-table/dist/bootstrap-table.min.css'
// import 'bootstrap-table/dist/bootstrap-table.min.js'
// import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN.min.js'
const Bus = new Vue();
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$http = http;
window.bus = Bus;

// $('html')[0].innerHTML = 'a'
px2rem();
window.onresize = function () {
    px2rem()
};

function px2rem() {
    var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
    if (deviceWidth >= 750) {
        deviceWidth = 750;
    }
    if (deviceWidth <= 320) {
        deviceWidth = 320;
    }
    document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px';
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
